// assets/kc-warranty-crosssell-popup.js
//
// Cross-sell popup shown on the PDP after an add-to-cart lands in the real
// cart (polling /cart.js and diffing line-item keys, rather than assuming
// the add succeeded — a sold-out or rejected add never shows a false
// "Agregado a tu carro"). Recommendations come from Bloomreach via
// exponea.getRecommendation(), with the block resolved via the
// cross_sell_rule metaobject (SKU > product_type > default).
//
// Deploy scope: cross-sell ONLY. This file intentionally does not include
// the garantía extendida / instalación "gate" popup that exists on the test
// theme (135229112375) — production's main-product.liquid does not dispatch
// a 'kc:warranty-gate' event, so that flow has no equivalent here yet.
(function () {
  var CROSS_OVERLAY_ID = 'kc-crosssell-only-overlay';

  // Default Bloomreach recommendation block. The legacy wl-cart banner picks
  // a more specific block per SKU/product_type via a Jinja if/elif chain that
  // lives in Bloomreach, not here — pending migration to a shared config.
  var CROSS_SELL_RECOMMENDATION_ID = '66352684297c0740595ada76';
  var CROSS_SELL_SIZE = 8;
  // Same event/shape the site's other carousels track, so this popup's clicks
  // land next to theirs in Bloomreach reports.
  var CROSS_SELL_CARRUSEL_NAME = 'Cross - Add to Cart';

  // Rules come from the cross_sell_rule metaobject, rendered by
  // main-product.liquid into a JSON <script> tag. Cached after first read.
  // Falls back to CROSS_SELL_RECOMMENDATION_ID whenever the tag is missing,
  // empty, or fails to parse — the popup must never end up with no block.
  var _crossSellRulesCache = null;
  function getCrossSellRules() {
    if (_crossSellRulesCache) return _crossSellRulesCache;
    var rules = [];
    try {
      var el = document.getElementById('kc-cross-sell-rules');
      if (el && el.textContent) {
        var parsed = JSON.parse(el.textContent);
        if (Array.isArray(parsed)) rules = parsed;
      }
    } catch (e) {
      rules = [];
    }
    _crossSellRulesCache = rules;
    return rules;
  }

  // SKU rules always outrank product_type rules, regardless of order in the
  // metaobject — matches how the equivalent Bloomreach Jinja is meant to work.
  function resolveCrossSellRecommendationId(item) {
    var rules = getCrossSellRules();
    if (!rules.length) return CROSS_SELL_RECOMMENDATION_ID;

    var sku = item && item.sku;
    var productType = item && item.product_type;

    if (sku) {
      for (var i = 0; i < rules.length; i++) {
        var r = rules[i];
        if (r.match_type === 'sku' && Array.isArray(r.skus) && r.skus.indexOf(sku) !== -1) {
          return r.recommendation_id || CROSS_SELL_RECOMMENDATION_ID;
        }
      }
    }
    if (productType) {
      for (var j = 0; j < rules.length; j++) {
        var rt = rules[j];
        if (rt.match_type === 'product_type' && Array.isArray(rt.product_types) && rt.product_types.indexOf(productType) !== -1) {
          return rt.recommendation_id || CROSS_SELL_RECOMMENDATION_ID;
        }
      }
    }
    for (var k = 0; k < rules.length; k++) {
      if (rules[k].match_type === 'default') return rules[k].recommendation_id || CROSS_SELL_RECOMMENDATION_ID;
    }
    return CROSS_SELL_RECOMMENDATION_ID;
  }

  /* ------------------------------------------------------------------ */
  /* Shared helpers                                                      */
  /* ------------------------------------------------------------------ */

  var scrollLockCount = 0;
  var savedBodyOverflow = '';
  function lockScroll() {
    if (scrollLockCount === 0) {
      savedBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    scrollLockCount++;
  }
  function unlockScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) document.body.style.overflow = savedBodyOverflow;
  }

  // Keeps the Bloomreach "wl-cart" banner hidden while the popup is open,
  // then restores it. subtree:true because the SDK injects nested, and we
  // sweep already-present nodes since the banner may predate the popup.
  function holdWlCartBanner() {
    var held = [];

    function hide(node) {
      if (held.indexOf(node) !== -1) return;
      held.push(node);
      node.style.setProperty('opacity', '0', 'important');
      node.style.setProperty('visibility', 'hidden', 'important');
      node.style.setProperty('pointer-events', 'none', 'important');
    }

    Array.prototype.forEach.call(document.querySelectorAll('.wl-cart'), hide);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('wl-cart')) hide(node);
          if (node.querySelectorAll) {
            Array.prototype.forEach.call(node.querySelectorAll('.wl-cart'), hide);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return function release() {
      observer.disconnect();
      held.forEach(function (node) {
        node.style.removeProperty('opacity');
        node.style.removeProperty('visibility');
        node.style.removeProperty('pointer-events');
      });
      held = [];
    };
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function cartKeys(cart) {
    var map = {};
    (cart.items || []).forEach(function (i) {
      map[i.key] = i.quantity;
    });
    return map;
  }

  // Polls the real cart until a new/increased line item shows up, then hands
  // back the item that was actually added. Resolves null on timeout so a
  // failed add simply shows nothing rather than a false confirmation.
  function waitForCartAddition(beforeKeys, preferVariantId, timeoutMs) {
    var deadline = Date.now() + (timeoutMs || 6000);

    function attempt() {
      return fetchCart()
        .then(function (cart) {
          var added = [];
          (cart.items || []).forEach(function (item) {
            var prev = beforeKeys[item.key];
            if (prev === undefined || item.quantity > prev) added.push(item);
          });

          var found = null;
          if (added.length) {
            if (preferVariantId) {
              added.forEach(function (item) {
                if (!found && String(item.variant_id) === String(preferVariantId)) found = item;
              });
            }
            if (!found) {
              added.forEach(function (item) {
                if (!found && item.product_type !== 'Warranty') found = item;
              });
            }
            if (!found) found = added[0];
          }
          if (found) return found;
          if (Date.now() >= deadline) return null;
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve(attempt());
            }, 400);
          });
        })
        .catch(function () {
          return null;
        });
    }
    return attempt();
  }

  // Recommendation feeds are external input — only allow real http(s) links.
  function safeUrl(url) {
    if (!url) return null;
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
      return parsed.href;
    } catch (e) {
      return null;
    }
  }

  function formatPrice(n) {
    return '$' + Math.round(n).toLocaleString('es-CL');
  }

  function buildCloseButton(className) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = className;
    btn.setAttribute('aria-label', 'Cerrar');
    btn.innerHTML =
      '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
    return btn;
  }

  // Wires Escape-to-close and restores focus to whatever the customer was on
  // before the popup stole it.
  function attachDismissBehaviour(overlay, onDismiss) {
    var previouslyFocused = document.activeElement;

    function onKeydown(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        onDismiss();
      }
    }
    document.addEventListener('keydown', onKeydown);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) onDismiss();
    });

    return function cleanup() {
      document.removeEventListener('keydown', onKeydown);
      if (previouslyFocused && previouslyFocused.focus) {
        try {
          previouslyFocused.focus();
        } catch (e) {
          /* element may be gone — harmless */
        }
      }
    };
  }

  function mountOverlay(overlay) {
    document.body.appendChild(overlay);
    lockScroll();
    // Force a style flush before .active so the transition plays. Deliberately
    // not requestAnimationFrame: some embedded webviews throttle rAF and would
    // leave the popup stuck at opacity:0.
    void overlay.offsetHeight;
    overlay.classList.add('active');
  }

  function unmountOverlay(overlay, onDone) {
    overlay.classList.remove('active');
    unlockScroll();
    setTimeout(function () {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      if (onDone) onDone();
    }, 250);
  }

  /* ------------------------------------------------------------------ */
  /* Trigger: detect a successful add-to-cart on the PDP's own form      */
  /* ------------------------------------------------------------------ */

  // Detected here rather than in main-product.liquid: that file's own submit
  // listener is bound ~1s after DOMContentLoaded to the forms present at that
  // moment, so on templates where the form is re-rendered afterwards it ends
  // up attached to a detached node. Delegation on `document` always matches
  // whatever form is live at submit time.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      if (!isMainProductForm(form)) return; // ignore quick-adds in carousels/drawer
      // Productos con bloques de garantía extendida / instalación siguen su
      // propio flujo inline (fetch directo a /cart/add.js cuando hay algo
      // marcado, o el submit nativo del form si no hay nada marcado) — este
      // listener nunca llama preventDefault/stopPropagation, así que no
      // interfiere con ese flujo. Solo observa el carrito real en paralelo
      // para saber si el agregado terminó pasando, sin importar el mecanismo,
      // y mostrar el cross-sell en ese caso. (Antes se saltaba por completo
      // cualquier producto con checkboxes de bundle, asumiendo que el gate
      // se encargaría de esto — pero producción no tiene gate, así que el
      // cross-sell nunca se disparaba para esos productos.)
      var mainVariantId = mainVariantOf(form);
      fetchCart()
        .then(cartKeys)
        .catch(function () {
          return {};
        })
        .then(function (beforeKeys) {
          return waitForCartAddition(beforeKeys, mainVariantId);
        })
        .then(function (addedItem) {
          if (addedItem) showCrossSellPopup(addedItem);
        });
    },
    true
  );

  function mainVariantOf(form) {
    var input = form && form.querySelector('[name="id"]');
    return input && input.value ? input.value : null;
  }

  // Only the PDP's own add-to-cart should trigger the popup — otherwise a
  // quick-add inside a "recommended products" carousel on the same page would
  // pop up confirming the wrong product.
  function isMainProductForm(form) {
    if (form.closest('cart-drawer, .cart-drawer, quick-add-modal, .quick-add-modal, .card, .kcb-right')) {
      return false;
    }
    return !!form.closest('.product, [id^="MainProduct-"], [id^="ProductInfo-"], .product-form-sticky, sticky-add-to-cart');
  }

  /* ------------------------------------------------------------------ */
  /* Popup: "Propuesta B" — confirmación + carrusel vertical             */
  /* ------------------------------------------------------------------ */

  // Columna izquierda de confirmación (imagen, nombre, precio, CTA al carro)
  // + columna derecha con el carrusel vertical de cross-sell. La confirmación
  // por sí sola ya es útil (foto real del producto + link al carro), así que
  // si Bloomreach no trae recomendaciones no se cierra el popup: solo se
  // oculta la columna derecha y la izquierda pasa a ocupar el ancho completo.
  function showCrossSellPopup(addedItem) {
    if (document.getElementById(CROSS_OVERLAY_ID)) return;

    var releaseWlCart = holdWlCartBanner();

    var overlay = document.createElement('div');
    overlay.className = 'kcb-overlay';
    overlay.id = CROSS_OVERLAY_ID;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Producto agregado al carro');

    var modal = document.createElement('div');
    modal.className = 'kcb-modal';

    var closeBtn = buildCloseButton('kcb-close');

    var scroll = document.createElement('div');
    scroll.className = 'kcb-scroll';

    var split = document.createElement('div');
    split.className = 'kcb-split';

    var left = buildConfirmPanel(addedItem);
    var cross = buildCrossSellPanel();

    split.appendChild(left);
    split.appendChild(cross.el);
    scroll.appendChild(split);
    modal.appendChild(closeBtn);
    modal.appendChild(scroll);
    overlay.appendChild(modal);

    mountOverlay(overlay);
    closeBtn.focus();

    var closed = false;
    var detachDismiss = attachDismissBehaviour(overlay, close);

    function close() {
      if (closed) return;
      closed = true;
      releaseWlCart();
      detachDismiss();
      cross.destroy();
      unmountOverlay(overlay);
    }

    closeBtn.addEventListener('click', close);

    loadCrossSell(cross, addedItem, function hasNoItems() {
      // El timeout de loadCrossSell (6s) puede disparar después de que el
      // usuario ya cerró el popup a mano — no tocar un split ya descartado.
      if (closed) return;
      // Sin recomendaciones: la columna izquierda (imagen + "Ir al carro")
      // sigue siendo útil por sí sola, así que no cerramos el popup — solo
      // se queda sin la segunda columna.
      split.classList.add('kcb-split--single');
    });
  }

  // Construida a partir del line item real del carrito (no del DOM de la
  // PDP), así que la imagen/nombre/precio siempre corresponden a lo que
  // efectivamente se agregó, incluida la variante correcta.
  function buildConfirmPanel(item) {
    var left = document.createElement('div');
    left.className = 'kcb-left';

    var confirm = document.createElement('div');
    confirm.className = 'kcb-confirm';

    var kicker = document.createElement('p');
    kicker.className = 'kcb-kicker';
    kicker.textContent = 'Agregado a tu carro';

    // "Primera imagen del producto agregado": cart.js ya devuelve la imagen
    // destacada de la línea, no hace falta ir a buscarla aparte.
    var hero = document.createElement('img');
    hero.className = 'kcb-hero';
    hero.alt = '';
    hero.setAttribute('aria-hidden', 'true');
    if (item && item.image) hero.src = item.image;

    var title = document.createElement('h2');
    title.className = 'kcb-title';
    title.textContent = 'Buena elección.';

    var name = document.createElement('p');
    name.className = 'kcb-added-name';
    name.textContent = (item && (item.product_title || item.title)) || '';

    var price = document.createElement('p');
    price.className = 'kcb-added-price';
    var priceVal = item && typeof item.final_price === 'number' ? item.final_price / 100 : null;
    price.textContent = priceVal != null ? formatPrice(priceVal) : '';

    confirm.appendChild(kicker);
    confirm.appendChild(hero);
    confirm.appendChild(title);
    confirm.appendChild(name);
    confirm.appendChild(price);

    var actions = document.createElement('div');
    actions.className = 'kcb-actions';
    var cartLink = document.createElement('a');
    cartLink.className = 'kcb-btn-primary';
    cartLink.href = '/cart';
    cartLink.textContent = 'Ir al carro';
    actions.appendChild(cartLink);

    left.appendChild(confirm);
    left.appendChild(actions);
    return left;
  }

  /* ------------------------------------------------------------------ */
  /* Cross-sell carousel                                                 */
  /* ------------------------------------------------------------------ */

  // Columna derecha: carrusel VERTICAL. Una barra fina al costado del
  // viewport indica cuánto queda por bajar — se actualiza en cada scroll.
  function buildCrossSellPanel() {
    var el = document.createElement('div');
    el.className = 'kcb-right';
    el.style.display = 'none'; // until we know we have real items

    var kicker = document.createElement('p');
    kicker.className = 'kcb-kicker';
    kicker.textContent = 'También te podría interesar';

    var h3 = document.createElement('h3');
    h3.textContent = 'Completa tu cocina.';

    var carousel = document.createElement('div');
    carousel.className = 'kcb-carousel';

    var viewport = document.createElement('div');
    viewport.className = 'kcb-viewport';
    var list = document.createElement('div');
    list.className = 'kcb-list';
    viewport.appendChild(list);

    var track = document.createElement('div');
    track.className = 'kcb-scrollbar';
    track.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('div');
    thumb.className = 'kcb-scrollbar__thumb';
    track.appendChild(thumb);

    carousel.appendChild(viewport);
    carousel.appendChild(track);

    var more = document.createElement('a');
    more.className = 'kcb-more';
    more.href = '/collections/all';
    more.textContent = 'Ver más productos';

    el.appendChild(kicker);
    el.appendChild(h3);
    el.appendChild(carousel);
    el.appendChild(more);

    function updateScrollbar() {
      var trackHeight = track.clientHeight;
      var scrollable = viewport.scrollHeight - viewport.clientHeight;

      if (scrollable <= 1) {
        // Nada que desplazar (ej. mobile, donde el viewport no tiene límite
        // de alto) — no mostrar una barra que no representa nada.
        track.style.visibility = 'hidden';
        return;
      }
      track.style.visibility = 'visible';

      var ratio = viewport.clientHeight / viewport.scrollHeight;
      var thumbHeight = Math.max(28, trackHeight * ratio);
      var thumbTop = (trackHeight - thumbHeight) * (viewport.scrollTop / scrollable);

      thumb.style.height = thumbHeight + 'px';
      thumb.style.top = thumbTop + 'px';
    }

    viewport.addEventListener('scroll', updateScrollbar);
    // 'scroll' en viewport se limpia solo (el nodo se descarta con el popup),
    // pero 'resize' vive en window y NO se limpia solo — sin destroy() acá,
    // cada apertura del popup deja un listener fantasma apuntando a nodos ya
    // removidos del DOM (memory leak si el usuario agrega varios productos
    // en la misma sesión).
    window.addEventListener('resize', updateScrollbar);
    function destroy() {
      window.removeEventListener('resize', updateScrollbar);
    }

    return { el: el, list: list, viewport: viewport, updateScrollbar: updateScrollbar, destroy: destroy };
  }

  function loadCrossSell(cross, addedItem, onEmpty) {
    if (typeof exponea === 'undefined' || typeof exponea.getRecommendation !== 'function') {
      if (onEmpty) onEmpty();
      return;
    }

    var settled = false;
    // If Bloomreach never answers, don't leave the popup waiting forever.
    var timeout = setTimeout(function () {
      if (!settled) {
        settled = true;
        if (onEmpty) onEmpty();
      }
    }, 6000);

    try {
      // Bloomreach's documented Web SDK contract: a SINGLE options object with
      // the callback inside it (not a second argument).
      exponea.getRecommendation({
        recommendationId: resolveCrossSellRecommendationId(addedItem),
        fillWithRandom: true,
        size: CROSS_SELL_SIZE,
        callback: function (data) {
          if (settled) return;
          settled = true;
          clearTimeout(timeout);

          var items = normalizeRecommendationResponse(data);
          // The popup may already be gone by the time this lands.
          if (!cross.list.isConnected) return;

          items.forEach(function (item) {
            var row = buildCrossSellRow(item);
            if (row) cross.list.appendChild(row);
          });

          if (cross.list.children.length) {
            cross.el.style.display = '';
            // Síncrono, no requestAnimationFrame: algunos webviews embebidos
            // lo suprimen y la barra quedaría sin medir hasta el primer
            // scroll manual del usuario.
            cross.updateScrollbar();
          } else if (onEmpty) {
            onEmpty();
          }
        },
      });
    } catch (e) {
      settled = true;
      clearTimeout(timeout);
      console.error('[kc-warranty-crosssell-popup] getRecommendation failed', e);
      if (onEmpty) onEmpty();
    }
  }

  // Field names confirmed live against this store's catalog feed — same shape
  // the existing wl-cart banner relies on.
  function normalizeRecommendationResponse(data) {
    if (!Array.isArray(data)) return [];

    return data
      .filter(function (item) {
        return item.active !== false && (item.stock_level == null || item.stock_level > 0);
      })
      .map(function (item) {
        return {
          // Must be a real variant id — item_id/sku would 4xx on /cart/add.js.
          variantId: item.variant_id != null ? String(item.variant_id) : null,
          title: pick(item, ['title_combined', 'product_title', 'title']),
          brand: pick(item, ['brand']),
          url: safeUrl(pick(item, ['url'])),
          image: safeUrl(pick(item, ['image'])),
          price: toNumber(pick(item, ['price'])),
          originalPrice: toNumber(pick(item, ['original_price'])),
        };
      })
      .filter(function (item) {
        return item.title && item.image;
      });
  }

  function pick(obj, keys) {
    if (!obj) return null;
    for (var i = 0; i < keys.length; i++) {
      if (obj[keys[i]] != null && obj[keys[i]] !== '') return obj[keys[i]];
    }
    return null;
  }

  function toNumber(v) {
    var n = parseFloat(v);
    return isNaN(n) ? null : n;
  }

  function trackCrossSellClick(interes, item) {
    if (typeof exponea === 'undefined' || typeof exponea.track !== 'function') return;
    try {
      exponea.track('click_carrusel', {
        'ubicación': 'PDP',
        carrusel_name: CROSS_SELL_CARRUSEL_NAME,
        'interés': interes,
        product_name: item.title,
        item_id: item.variantId,
      });
    } catch (e) {
      /* tracking must never break the interaction */
    }
  }

  // Fila de la lista/carrusel vertical: imagen | marca+nombre+precio |
  // "Agregar". Precio: normal (tachado) primero, oferta después, descuento
  // como badge con fondo rojo.
  function buildCrossSellRow(item) {
    var row = document.createElement('div');
    row.className = 'kcb-row';

    var imgLink = document.createElement('a');
    imgLink.href = item.url || '#';
    imgLink.addEventListener('click', function () {
      trackCrossSellClick('view', item);
    });

    var img = document.createElement('img');
    img.className = 'kcb-row__img';
    img.src = item.image;
    img.alt = item.title;
    img.loading = 'lazy';
    imgLink.appendChild(img);

    var copy = document.createElement('div');
    copy.className = 'kcb-row__copy';

    if (item.brand) {
      var brandEl = document.createElement('span');
      brandEl.className = 'kcb-row__brand';
      brandEl.textContent = item.brand;
      copy.appendChild(brandEl);
    }

    var nameLink = document.createElement('a');
    nameLink.href = item.url || '#';
    nameLink.className = 'kcb-row__name';
    nameLink.textContent = item.title;
    nameLink.addEventListener('click', function () {
      trackCrossSellClick('view', item);
    });
    copy.appendChild(nameLink);

    if (item.price != null) {
      var priceRow = document.createElement('div');
      priceRow.className = 'kcb-prices';
      if (item.originalPrice != null && item.originalPrice > item.price) {
        var discount = Math.round(((item.originalPrice - item.price) / item.originalPrice) * 100);
        priceRow.innerHTML =
          '<span class="kcb-price kcb-price--was">' + formatPrice(item.originalPrice) + '</span>' +
          '<span class="kcb-price">' + formatPrice(item.price) + '</span>' +
          '<span class="kcb-off">-' + discount + '%</span>';
      } else {
        priceRow.innerHTML = '<span class="kcb-price">' + formatPrice(item.price) + '</span>';
      }
      copy.appendChild(priceRow);
    }

    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'kcb-btn-outline';
    addBtn.textContent = 'Agregar';
    if (!item.variantId) {
      // No usable variant id — offer the product page instead of a button that
      // would silently fail.
      addBtn.textContent = 'Ver producto';
      addBtn.addEventListener('click', function () {
        trackCrossSellClick('view', item);
        if (item.url) window.location.href = item.url;
      });
    } else {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        addBtn.disabled = true;
        addBtn.textContent = 'Agregando…';
        trackCrossSellClick('add', item);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: item.variantId, quantity: 1 }],
            // Ask for the rendered sections so the drawer/bubble stay in sync
            // instead of drifting out of date behind the popup.
            sections: ['cart-drawer', 'cart-icon-bubble'],
          }),
        })
          .then(function (r) {
            return r.json().then(function (payload) {
              if (!r.ok) throw new Error(payload && payload.description ? payload.description : 'add failed');
              return payload;
            });
          })
          .then(function (payload) {
            syncCartUi(payload);
            addBtn.textContent = '¡Agregado!';
            setTimeout(function () {
              addBtn.disabled = false;
              addBtn.textContent = 'Agregar';
            }, 1800);
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = 'No disponible';
            setTimeout(function () {
              addBtn.textContent = 'Agregar';
            }, 2500);
          });
      });
    }

    row.appendChild(imgLink);
    row.appendChild(copy);
    row.appendChild(addBtn);
    return row;
  }

  // Keeps the rest of the theme (drawer contents, count bubble, any cartUpdate
  // subscriber) consistent after an add made outside the normal product form.
  function syncCartUi(payload) {
    try {
      if (payload && payload.sections) {
        var parser = new DOMParser();
        if (payload.sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) bubble.innerHTML = payload.sections['cart-icon-bubble'];
        }
        if (payload.sections['cart-drawer']) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer) {
            var doc = parser.parseFromString(payload.sections['cart-drawer'], 'text/html');
            var incoming = doc.querySelector('#CartDrawer');
            var current = drawer.querySelector('#CartDrawer');
            if (incoming && current) current.innerHTML = incoming.innerHTML;
            drawer.classList.remove('is-empty');
          }
        }
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kc-crosssell-popup', cartData: payload });
      }
    } catch (e) {
      /* UI sync is best-effort — the item is already in the cart */
    }
  }
})();
